<template>
  <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
    <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">OZiVu</a>
    <span class="navbar-text">
      Bonjour, {{firstName}}!
    </span>
    <ul class="navbar-nav px-3">
      <li class="nav-item text-nowrap">
        <a class="nav-link" v-on:click='logout'>Déconnexion</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data: function() {return {
    nom: "Chose"
  }},
  computed: {
    firstName() {
      return localStorage.firstName;
      // return this.$root.$data.firstName;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('jwt');
      this.$router.push('/login');
    }
  }
}
</script>
